<script setup>
import { cn } from "@/lib/utils"
import { Input } from "@/components/ui/input"
import { useVModel } from "@vueuse/core"

const props = defineProps({
    defaultValue: { type: [String, Number], required: false },
    modelValue: { type: [String, Number], required: false },
    class: { type: null, required: false }
})

const emit = defineEmits(['update:modelValue'])

const modelValue = useVModel(props, "modelValue", emit, {
    passive: true,
    defaultValue: props.defaultValue,
})
</script>

<template>
  <Input
    v-model="modelValue"
    data-slot="input-group-control"
    :class="cn(
      'flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent',
      props.class,
    )"
  />
</template>